<template>
  <v-form ref="userForm" v-model="valid">
    <v-layout style="width: 100%" row wrap pb-2>
      <v-flex xs12 pl-2>
        <v-layout class="field-padding" row wrap>
          <v-flex xs6 md4 px-2>
            <v-text-field
              :error-messages="errorForField('name')"
              :rules="userRules.name"
              prepend-inner-icon="person"
              v-model="user.name"
              label="Full Name (*)"
              @input="resetError('name')"
            />
          </v-flex>
          <v-flex xs6 md4 px-2>
            <v-text-field
              :error-messages="errorForField('contact_number')"
              :rules="userRules.contact_number"
              type="number"
              class="noStepNumber"
              prepend-inner-icon="smartphone"
              v-model="user.contact_number"
              label="Mobile Number (*)"
              @input="resetError('contact_number')"
            />
          </v-flex>
          <v-flex xs6 md4 px-2>
            <v-text-field
              :error-messages="errorForField('email')"
              :rules="userRules.email"
              prepend-inner-icon="email"
              v-model="user.email"
              label="Email (*)"
              @input="resetError('email')"
              browser-autocomplete="new-email"
            />
          </v-flex>
          <v-flex xs6 md4 px-2>
            <v-text-field
              :error-messages="errorForField('password')"
              :rules="userRules.password"
              :append-icon="showPassword ? 'visibility' : 'visibility_off'"
              prepend-inner-icon="lock"
              :type="showPassword ? 'text' : 'password'"
              v-model="user.password"
              label="Password (*)"
              @input="resetError('password')"
              @click:append="showPassword = !showPassword"
              browser-autocomplete="new-password"
            />
          </v-flex>
          <v-flex xs6 md4 px-2>
            <v-text-field
              :error-messages="errorForField('accounting_reference_number')"
              v-model="user.accounting_reference_number"
              label="Accounting Reference Number"
              @input="resetError('accounting_reference_number')"
            />
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-form>
</template>

<script>
export default {
  name: "user_form",
  components: {},
  props: {
    user: Object,
    disabled: Boolean,
    editingUser: false,
    errors: { type: Object, default: () => {} },
  },
  data: function () {
    return {
      valid: false,
      showPassword: false,
      userRules: {
        name: [
          (v) => !!v || "Name is required",
          (v) => (v && v.length <= 100) || "Name cannot exceed 100 characters",
        ],
        email: [
          (v) => !!v || "Email is required",
          (v) => /.+@.+/.test(v) || "Email must be valid",
        ],
        contact_number: [(v) => !!v || "Mobile number is required"],
        password: [(v) => this.editingUser || !!v || "Password is required"],
      },
    };
  },
  methods: {
    errorForField: function (field) {
      try {
        return this.errors[field];
      } catch (err) {
        return null;
      }
    },
    resetError: function (field) {
      try {
        if (this.errors[field] != "") {
          this.errors[field] = "";
        }
      } catch (err) {}
    },
    validateForm: function () {
      this.$refs.userForm.validate();
    },
  },
  watch: {
    disabled: function () {
      this.$refs.userForm.reset();
    },
    valid: function () {
      this.$emit("validityChange", this.valid);
    },
  },
};
</script>

<style>
.noStepNumber input[type="number"] {
  -moz-appearance: textfield;
}
.noStepNumber input::-webkit-outer-spin-button,
.noStepNumber input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}
</style>
